import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import { keyframes } from "@emotion/react";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const rotateArc = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const pulseRing = keyframes`
  0%, 100% {
    opacity: 0.28;
    transform: scale(0.92);
  }
  50% {
    opacity: 0.55;
    transform: scale(1);
  }
`;

const cursorFloat = keyframes`
  0%, 100% {
    transform: translate(32px, 16px);
  }
  50% {
    transform: translate(38px, 10px);
  }
`;

export default function FreightCalculationLoadingModal({ open }) {
  return (
    <Modal
      open={open}
      aria-labelledby="freight-calculation-loading-title"
      aria-describedby="freight-calculation-loading-description"
      disableAutoFocus
      disableEnforceFocus
      disableEscapeKeyDown
      hideBackdrop={false}
      BackdropProps={{
        sx: {
          background:
            "linear-gradient(180deg, rgba(248,250,252,0.86), rgba(248,250,252,0.94))",
          backdropFilter: "blur(1px)",
        },
      }}
    >
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          outline: "none",
          pointerEvents: "none",
        }}
      >
        <Box
          sx={{
            width: "min(100%, 360px)",
            minHeight: 330,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 150,
              height: 150,
              mb: 3,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 12,
                borderRadius: "50%",
                border: "2px solid rgba(2,132,199,0.14)",
                animation: `${pulseRing} 1.8s ease-in-out infinite`,
              }}
            />

            <Box
              sx={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                border: "4px solid transparent",
                borderTopColor: "#FF3100",
                borderLeftColor: "#FF3100",
                animation: `${rotateArc} 1.15s linear infinite`,
              }}
            />

            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: 72,
                height: 72,
                transform: "translate(-50%, -50%)",
                borderRadius: "50%",
                bgcolor: "#FF3100",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: 23,
                fontWeight: 700,
                letterSpacing: 2,
                boxShadow: "0 16px 34px rgba(209, 64, 7, 0.24)",
              }}
            >
              <LocalShippingIcon sx={{ fontSize: 40 }} />
            </Box>

            
          </Box>

          <Typography
            id="freight-calculation-loading-title"
            sx={{
              color: "#111827",
              fontSize: { xs: 26, sm: 28 },
              fontWeight: 700,
              lineHeight: 1.2,
              mb: 1,
            }}
          >
           
            Por favor, aguarde um momento.
          </Typography>

          <Typography
            id="freight-calculation-loading-description"
            sx={{
              color: "#6b7280",
              fontSize: 18,
              lineHeight: 1.45,
              fontWeight: 500,

            }}
          >
            
            Calculando o frete....
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}
